/**
 * Catálogo único de métodos de pago para Gas2GO.
 *
 * Cada método tiene:
 *  - id: identificador persistido en MongoDB y enviado al backend.
 *  - label: nombre corto mostrado al cliente.
 *  - description: subtexto bajo el nombre.
 *  - kind: "cash" | "online" | "transfer" — controla cómo se procesa
 *          el pedido en el backend. "online" pasa por Stripe.
 *  - color: hex del color de la marca (sirve para tints en UI).
 *
 * Los iconos/logos se renderizan con el componente
 * <PaymentLogo id={id}/> (SVG inline, sin dependencia de CDN externos).
 *
 * Importante: el cliente sólo ve los métodos que la empresa ha
 * habilitado en su tab "Configuración → Métodos de pago".
 */
export const PAYMENT_METHODS = [
  {
    id: "cash",
    label: "Efectivo al entregar",
    description: "Paga al recibir tu pedido",
    kind: "cash",
    color: "#16a34a",
  },
  {
    id: "stripe",
    label: "Pago en línea (Stripe)",
    description: "Tarjeta de crédito o débito",
    kind: "online",
    color: "#635BFF",
  },
  {
    id: "bbva",
    label: "Transferencia BBVA",
    description: "Sube comprobante después de pagar",
    kind: "transfer",
    color: "#004481",
  },
  {
    id: "santander",
    label: "Transferencia Santander",
    description: "Sube comprobante después de pagar",
    kind: "transfer",
    color: "#EC0000",
  },
  {
    id: "hsbc",
    label: "Transferencia HSBC",
    description: "Sube comprobante después de pagar",
    kind: "transfer",
    color: "#DB0011",
  },
];

/** Default usado cuando la empresa todavía no ha configurado nada. */
export const DEFAULT_ENABLED_METHODS = ["cash", "stripe"];

/** Devuelve los métodos habilitados para la empresa actual, en el
 *  mismo orden definido en `PAYMENT_METHODS`. Acepta None o lista vacía
 *  y cae al default. */
export function enabledPaymentMethods(company) {
  const ids = company?.payment_methods;
  const list = Array.isArray(ids) && ids.length > 0 ? ids : DEFAULT_ENABLED_METHODS;
  return PAYMENT_METHODS.filter((m) => list.includes(m.id));
}

/** Helper para mostrar el label legible en pantallas de resumen, admin,
 *  emails, etc. Acepta tanto el id canónico como el legacy "online". */
export function paymentMethodLabel(id) {
  const norm = id === "online" ? "stripe" : id;
  const m = PAYMENT_METHODS.find((p) => p.id === norm);
  return m ? m.label : id;
}
